module.exports = __webpack_public_path__ + "img/page_sms_image.4daac8fc.png";